import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAdminAccounts } from './HomePage';
import { normalizeBangladeshPhone } from '../utils/phone';
import './AdminAuth.css';

export function AdminLoginPage() {
  const navigate = useNavigate();
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    setError('');

    const adminAccounts = await getAdminAccounts();
    const normalizedPhone = normalizeBangladeshPhone(phone);
    const isMatch = Boolean(normalizedPhone) && adminAccounts.some((admin) => {
      const adminPhone = normalizeBangladeshPhone(admin.phone || admin.phoneNumber || '');
      return adminPhone === normalizedPhone && String(admin.password) === String(password);
    });

    setIsSubmitting(false);

    if (isMatch) {
      localStorage.setItem('earneeds_admin_session', JSON.stringify({ phone: normalizedPhone }));
      navigate('/admin');
      return;
    }

    setError('Invalid phone number or password.');
  };

  return (
    <div className="admin-auth-page">
      <div className="admin-auth-card">
        <div className="admin-brand-row">
          <div className="brand-wrap">
            <img className="brand-logo" src="/logo.png" alt="Earneeds logo" />
            <div className="brand-copy">
              <span className="brand-name">Earneeds</span>
              <span className="brand-tag">Learn • Work • Earn</span>
            </div>
          </div>
        </div>

        <h2>Admin Login</h2>
        <form onSubmit={handleSubmit} className="admin-form">
          <label>
            Phone Number
            <input type="tel" value={phone} onChange={(event) => setPhone(event.target.value)} placeholder="Enter admin phone number" />
          </label>
          <label>
            Password
            <input type="password" value={password} onChange={(event) => setPassword(event.target.value)} placeholder="Enter admin password" />
          </label>
          {error && <div className="form-error">{error}</div>}
          <button type="submit" className="login-submit" disabled={isSubmitting}>
            {isSubmitting ? 'Checking...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
}
